import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, forwardRef, Input, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-checkbox',
    templateUrl: './checkbox.component.html',
    styleUrls: ['./checkbox.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CheckboxComponent),
            multi: true,
        },
    ],
})
export class CheckboxComponent implements ControlValueAccessor {
    @Input() id = 'checkbox';
    @Input() label: string;
    @Input() checked = false;
    @Input() invalid = false;

    @Input() disabled = false;

    @Output() checkedChange = new EventEmitter<boolean>();

    /* eslint-disable @typescript-eslint/no-empty-function */
    private onChangeFn: (value: boolean) => void = () => {};
    private onTouchedFn: () => void = () => {};
    /* eslint-enable @typescript-eslint/no-empty-function */

    constructor(private changeDetectorRef: ChangeDetectorRef) {}

    onChange(event: Event): void {
        const input = event.target as HTMLInputElement;
        const value = input.checked;

        input.checked = this.checked;

        this.emitChange(value);
    }

    onLabelClick(event: MouseEvent): void {
        event.preventDefault();

        if (!this.disabled) {
            this.emitChange(!this.checked);
        }
    }

    onBlur(): void {
        this.onTouchedFn();
    }

    writeValue(value: boolean | null): void {
        this.checked = value ?? false;
        this.changeDetectorRef.markForCheck();
    }

    registerOnChange(fn: (value: boolean) => void): void {
        this.onChangeFn = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouchedFn = fn;
    }

    setDisabledState(disabled: boolean): void {
        this.disabled = disabled;
        this.changeDetectorRef.markForCheck();
    }

    private emitChange(value: boolean): void {
        this.checked = value;
        this.checkedChange.emit(value);
        this.onChangeFn(value);
    }
}
